import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({
  children,
  requirePermission = null,
  requireSuperAdmin = false,
}) => {
  const { isAuthenticated, hasPermission, loading, user } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          bgcolor: "#f5f5f7",
        }}
      >
        <CircularProgress size={40} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          Verificando autenticação...
        </Typography>
      </Box>
    );
  }

  // Verificar se está autenticado
  if (!isAuthenticated()) {
    // Salvar a rota que o usuário tentou acessar para redirecionar depois do login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar se requer Super Admin
  if (requireSuperAdmin && (!user || !user.is_super_admin)) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          bgcolor: "#f5f5f7",
          p: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, color: "#d32f2f" }}>
          Acesso Restrito
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          Esta área é exclusiva para administradores do sistema.
        </Typography>
      </Box>
    );
  }

  // Verificar permissões específicas se necessário
  if (requirePermission && !hasPermission(requirePermission)) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          bgcolor: "#f5f5f7",
          p: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, color: "#d32f2f" }}>
          Acesso negado
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          Você não tem permissão para acessar esta página.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Usuário atual: {user?.nome}
        </Typography>
      </Box>
    );
  }

  // Se passou por todas as verificações, renderizar o componente
  return children;
};

export default ProtectedRoute;
